import { useEffect, useState } from 'react';
import { usePlanetPanelStore, type ActivityEntryWire } from './state/planetPanelStore';

/** Live feed of recent plant / dismantle / depleted events for this planet. */
export function PlanetActivityLog() {
  const activity = usePlanetPanelStore((s) => s.activity);
  const [now, setNow] = useState(Date.now());

  // Tick once a minute to keep the "X ago" labels fresh.
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);

  if (activity.length === 0) {
    return (
      <div style={{ color: '#6a7c8c', fontSize: 12, fontStyle: 'italic' }}>
        No recent activity.
      </div>
    );
  }

  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0, fontSize: 12 }}>
      {activity.slice(0, 10).map((entry, idx) => (
        <li
          key={entry.id ?? `${entry.created_at}-${idx}`}
          style={{
            padding: '6px 8px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
            color: tintFor(entry.event_type),
          }}
        >
          <div>{entry.message}</div>
          <div style={{ color: '#4a5a6a', fontSize: 10 }}>{ago(entry.created_at, now)}</div>
        </li>
      ))}
    </ul>
  );
}

function tintFor(eventType: ActivityEntryWire['event_type']): string {
  switch (eventType) {
    case 'plant':            return '#9fd8a3';
    case 'dismantle':        return '#d8d09f';
    case 'depleted':         return '#d8a39f';
    case 'auto_dismantle':   return '#d8639f';
    case 'claim':            return '#9fc6d8';
    case 'reactivated':      return '#9fd8c6';
    case 'geological_shift': return '#c39fd8';
  }
}

function ago(iso: string, now: number): string {
  const dt = now - new Date(iso).getTime();
  if (dt < 60_000) return 'just now';
  if (dt < 3_600_000) return `${Math.floor(dt / 60_000)}m ago`;
  if (dt < 86_400_000) return `${Math.floor(dt / 3_600_000)}h ago`;
  return `${Math.floor(dt / 86_400_000)}d ago`;
}
